// Exports true if environment provides native `WeakMap` implementation, whatever that is.
/*es6-weak-map/is-native-implemented*/
function _(require, module, exports) {
    module.exports = function () {
        if (typeof WeakMap !== 'function')
            return false;
        return Object.prototype.toString.call(new WeakMap()) === '[object WeakMap]';
    }();
}